import { CpdlcDialog } from "./cpdlcDialog.js";
export const openCpdlcDialogStates = ["SNT", "SBY", "TIM", "RCVD"];
export const abnormalCpdlcDialogStates = ["UNA", "UNA*", "NS", "NS*", "ERR", "FAIL"];
export const cancellableCpdlcDialogStates = ["SNT", "SBY", "TIM"];
export const deleteCpdlcDialogStates = ["WIL", "ROG"];
export class EramCpdlcDialog extends CpdlcDialog {
    logicalDataAuthority;
    eramState;
    constructor(message, logicalDataAuthority = null, eramState = ["N", "NE"].includes(message.responseAttribute) ? "NRR" : "SNT") {
        super(message);
        this.logicalDataAuthority = logicalDataAuthority;
        this.eramState = eramState;
        if (message.eramMsgType === "NBNS" || message.eramMsgType === "BBNS") {
            this.eramState = message.dueToReason ? "NS*" : "NS";
            this.closureDueToReason = message.dueToReason;
            this.status = "CLOSED";
        }
    }
    acknowledgedAt;
    deleted = false;
    cancelledAt;
    statusTime = Date.now();
    statusIndicatorMsgId;
    closureDueToReason;
    eligiblePosition = null;
    isSystemClosed = false;
    static setDialogStatus(dialog, status) {
        dialog.eramState = status;
        dialog.statusTime = Date.now();
    }
    static dialogIsClosed(dialog) {
        return dialog.status === "CLOSED" || !openCpdlcDialogStates.includes(dialog.eramState) || !!dialog.cancelledAt;
    }
}
//# sourceMappingURL=eramCpdlcDialog.js.map